type Callback = (...args: unknown[]) => unknown;

export default function debounce(callback: Callback, wait: number) {
	let timeoutId: ReturnType<typeof setTimeout>;

	return (...args: unknown[]) => {
		window.clearTimeout(timeoutId);

		timeoutId = window.setTimeout(() => {
			callback(...args);
		}, wait);
	};
}
